import React from 'react';
import { Autocomplete, Chip, TextField } from '@mui/material';
import PhoneInTalkOutlined from '@mui/icons-material/PhoneInTalkOutlined';

// Task types as seen in the Regal telephony export -- this filter is a
// UI-only preview (no data behind it yet) so the list is a static constant
// rather than derived from a live snapshot.
export const TASK_TYPE_OPTIONS = [
  'Triggered Outbound Call',
  'Manual Outbound Call',
  'Inbound Call',
  'Scheduled Callback',
  'ASAP Callback',
  'Transfer Call',
] as const;

interface TaskTypeFilterSelectProps {
  value: string[];
  onChange: (types: string[]) => void;
  disabled?: boolean;
}

export default function TaskTypeFilterSelect({
  value,
  onChange,
  disabled,
}: TaskTypeFilterSelectProps) {
  return (
    <Autocomplete
      multiple
      size="small"
      limitTags={1}
      value={value}
      onChange={(_e, next) => onChange(next)}
      options={TASK_TYPE_OPTIONS as unknown as string[]}
      disabled={disabled}
      disableCloseOnSelect
      autoHighlight
      sx={{ width: 220 }}
      renderTags={(selected, getTagProps) =>
        selected.map((type, index) => (
          <Chip
            {...getTagProps({ index })}
            key={type}
            size="small"
            label={type}
            sx={{ height: 20, '& .MuiChip-label': { px: 0.75, fontSize: 11 } }}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={value.length ? '' : 'All task types'}
          label="Task type"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <PhoneInTalkOutlined sx={{ fontSize: 16, color: 'text.disabled', ml: 0.5, mr: -0.25 }} />
                {params.InputProps.startAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
